import { z } from 'zod';

export const codeFormSchema = z.object({
  code: z.string().regex(/^\d{4}$/),
});

export type TCodeFormSchema = z.infer<typeof codeFormSchema>;
